import React from "react"
import PropTypes from "prop-types"
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { document } from "browser-monads"

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share"

import "./shareButtons.scss"

import HyperlinkShareIcon from "../../../images/svg/icons/hyperlink.svg"

const ShareButtons = ({ ...props }) => {
  let copyText = {
    normal: "Copy URL",
    complete: "Copied!",
    error: "There was an error.",
  }

  let ctcText = copyText.normal

  const copyToClipboard = () => {
    try {
      const el = document.createElement("textarea")

      el.classList.add("hidden")
      el.value = props.url
      el.readOnly = true

      document.body.appendChild(el)
      el.select()
      document.execCommand("copy")
      document.body.removeChild(el)

      ctcText = copyText.complete
      setTimeout(() => {
        ctcText = copyText.normal
      }, 1500)
    } catch (e) {
      console.log(e)

      ctcText = copyText.error
      setTimeout(() => {
        ctcText = copyText.normal
      }, 1500)
    }
  }

  return (
    <div className={`share-buttons container ${props.className}`}>
      <ul>
        <li data-for="fb-share" data-tip="Share to Facebook">
          {FacebookShareButton
            ? <FacebookShareButton url={props.url}>
                <FacebookIcon iconFillColor="#FFF" round={true} size={40} />
              </FacebookShareButton>
            : null
          }
        </li>
        <li data-for="tw-share" data-tip="Share to Twitter">
          {TwitterShareButton
            ? <TwitterShareButton url={props.url}>
                <TwitterIcon iconFillColor="#FFF" round={true} size={40} />
              </TwitterShareButton>
            : null
          }

        </li>
        <li
          data-for="copy-to-cb"
          data-tip={ctcText}
          onClick={() => {
            copyToClipboard()
          }}
        >
          <HyperlinkShareIcon />
        </li>
      </ul>
      <ReactTooltip id="fb-share" effect="solid" backgroundColor="#000" />
      <ReactTooltip id="tw-share" effect="solid" backgroundColor="#000" />
      <ReactTooltip
        id="copy-to-cb"
        effect="solid"
        backgroundColor="#000"
        getContent={[
          () => {
            return ctcText
          },
          1,
        ]}
      />
    </div>
  )
}

export default ShareButtons

ShareButtons.propTypes = {
  url: PropTypes.string.isRequired,
}
